import { useState } from "react";
import { getPipelineV2RunsPaginated, deletePipelineV2Run } from "./service";

export default usePipelineV2RunsPaginated;

function usePipelineV2RunsPaginated(workspaceId, pipelineId) {
  const [pipelineV2Runs, setPipelineV2Runs] = useState({
    pipelineRuns: [],
    pagination: {
      page: 1,
      pageSize: 10,
      totalRuns: 0,
      totalPages: 1,
    },
  });
  const [isPipelineV2RunsLoading, setIsPipelineV2RunsLoading] =
    useState<boolean>(true);

  const fetchPaginatedPipelineV2Runs = async (query, loading = false) => {
    setIsPipelineV2RunsLoading(loading);

    try {
      const request = {
        params: { workspaceId },
        query: {
          pipelineId,
          ...query,
        },
      };

      const response = await getPipelineV2RunsPaginated(request);

      setIsPipelineV2RunsLoading(false);
      setPipelineV2Runs({
        pipelineRuns: response.data.pipelineRuns,
        pagination: response.data.pagination,
      });
    } catch (e) {
      setIsPipelineV2RunsLoading(false);
    }
  };

  const removePipelineV2Run = async (pipelineRunId: string, lifecycleCbs) => {
    lifecycleCbs.init();

    try {
      const request = { params: { workspaceId, pipelineRunId } };
      const response = await deletePipelineV2Run(request);
      lifecycleCbs.success();
      fetchPaginatedPipelineV2Runs(
        { page: pipelineV2Runs.pagination.page },
        false,
      );
    } catch (e) {
      lifecycleCbs.error(e);
    }
  };

  return {
    pipelineV2Runs,
    isPipelineV2RunsLoading,
    removePipelineV2Run,
    fetchPaginatedPipelineV2Runs,
  };
}
